// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"TextEditor_toolbar__2R6qS","editor":"TextEditor_editor__uz3Tg"};